@for (item of items(); track item.entry.id) {
  <div [class]="item.classes">
    <vx-toast
      [tone]="item.entry.tone"
      [toast]="item.entry"
      [compact]="item.compact"
      [paused]="toasts.paused()"
      (actionPressed)="runAction(item.entry)"
      (menuItemSelected)="runMenuItem(item.entry, $event)"
      (menuOpened)="toasts.pauseForMenu(item.entry.id)"
      (menuClosed)="toasts.resumeForMenu(item.entry.id)"
      (dismissed)="toasts.dismiss(item.entry.id)" />
  </div>
}
